import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ThemeConfigurationSkeleton = () => {
  return (
    <Styles.Container>
      <Skeleton variant="text" width="100%" height={20} />

      <Styles.TabsRow>
        <Skeleton variant="rounded" width={160} height={36} />
        <Skeleton variant="rounded" width={160} height={36} />
        <Skeleton variant="rounded" width={120} height={36} />
      </Styles.TabsRow>

      <Styles.ContentLayout>
        <Styles.LeftColumn>
          <Skeleton variant="text" width={200} height={24} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="rounded" width="100%" height={56} />
          <Skeleton variant="text" width={200} height={24} />
          <Skeleton variant="rounded" width="100%" height={120} />
        </Styles.LeftColumn>

        <Styles.RightColumn>
          <Skeleton variant="rounded" width="100%" height={400} />
        </Styles.RightColumn>
      </Styles.ContentLayout>
    </Styles.Container>
  )
}

export default ThemeConfigurationSkeleton
